import { ClerkAxiosSetup } from '@/api/ClerkAxiosSetup';
import { Toaster } from '@/components/design-system/sooner';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { useMockServiceWorker } from '@/hooks/useMockServiceWorker';
import { LocaleStoreSyncProvider } from '@/i18n/LocaleStoreSyncProvider';
import { AuthProvider } from '@/providers/AuthProvider';
import { MatchMediaContextProvider } from '@/providers/MatchMediaProvider';
import { router } from '@/routing/router';
import { ClerkProvider } from '@clerk/clerk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';

export const queryClient = new QueryClient();

export const Providers: React.FC = () => {
  const { isReady } = useMockServiceWorker();

  if (!isReady) {
    return null;
  }

  return (
    <ErrorBoundary>
      <ClerkProvider publishableKey={String(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY)}>
        <ClerkAxiosSetup>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <MatchMediaContextProvider>
                <RouterProvider router={router} />
                <Toaster richColors />
              </MatchMediaContextProvider>
            </AuthProvider>
            <LocaleStoreSyncProvider />
          </QueryClientProvider>
        </ClerkAxiosSetup>
      </ClerkProvider>
    </ErrorBoundary>
  );
};
